import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import './Crossword.css';

const Crossword = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const [userId, setUserId] = useState(authState.user._id);
  const [currentTextInput, setCurrentTextInput] = useState(null);
  const [puzzleArrayData, setPuzzleArrayData] = useState([]);
  const [timer, setTimer] = useState(0);
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const [puzzleTitle, setPuzzleTitle] = useState("Dr. Gajanan Rashinkar Chemistry Crossword - Class IX");

  // const clues = [
  //   {
  //     clueDirection: "Horizontal",
  //     hintNo: "1",
  //     clue: "Capital of Bihar",
  //     answer: "Patna",
  //     numberOfChar: 5
  //   },
  //   {
  //     clueDirection: "Horizontal",
  //     hintNo: "2",
  //     clue: "Cultural Hub",
  //     answer: "Hyderabad",
  //     numberOfChar: 9
  //   },
  //   {
  //     clueDirection: "Horizontal",
  //     hintNo: "3",
  //     clue: "India's financial capital",
  //     answer: "Mumbai",
  //     numberOfChar: 6
  //   },
  //   {
  //     clueDirection: "Horizontal",
  //     hintNo: "4",
  //     clue: "Saffron region",
  //     answer: "Kashmir",
  //     numberOfChar: 6
  //   },
  //   {
  //     clueDirection: "Vertical",
  //     hintNo: "1",
  //     clue: "Education Hub",
  //     answer: "Pune",
  //     numberOfChar: 4
  //   },
  //   {
  //     clueDirection: "Vertical",
  //     hintNo: "2",
  //     clue: "Information Technology Hub",
  //     answer: "Bangalore",
  //     numberOfChar: 9
  //   },
  //   {
  //     clueDirection: "Vertical",
  //     hintNo: "3",
  //     clue: "Capital of India",
  //     answer: "Delhi",
  //     numberOfChar: 5
  //   }
  // ];

  const clues = [
    {
      clueDirection: "Horizontal",
      hintNo: "1",
      clue: "A noble gas with symbol He",
      answer: "Helium",
      numberOfChar: 6
    },
    {
      clueDirection: "Horizontal",
      hintNo: "2",
      clue: "Element chosen as standard reference for measuring atomic masses",
      answer: "Carbon",
      numberOfChar: 6
    },
    {
      clueDirection: "Horizontal",
      hintNo: "3",
      clue: "Atomic theory proposed by",
      answer: "Dalton",
      numberOfChar: 6
    },
    {
      clueDirection: "Horizontal",
      hintNo: "4",
      clue: "Positively charged particle in an atom",
      answer: "Proton",
      numberOfChar: 6
    },
    {
      clueDirection: "Horizontal",
      hintNo: "5",
      clue: "Negatively charged particle in an atom",
      answer: "Electron",
      numberOfChar: 8
    },
    {
      clueDirection: "Vertical",
      hintNo: "1",
      clue: "Neutral particle within the nucleus of an atom",
      answer: "Neutron",
      numberOfChar: 7
    },
    {
      clueDirection: "Vertical",
      hintNo: "2",
      clue: "Smallest particle of a compound",
      answer: "Molecule",
      numberOfChar: 8
    },
    {
      clueDirection: "Vertical",
      hintNo: "3",
      clue: "Molecules with two atoms",
      answer: "Diatomic",
      numberOfChar: 8
    },
    {
      clueDirection: "Vertical",
      hintNo: "4",
      clue: "Positively charged ion",
      answer: "Cation",
      numberOfChar: 6
    },
    {
      clueDirection: "Vertical",
      hintNo: "5",
      clue: "Charged particle",
      answer: "Ion",
      numberOfChar: 3
    }
  ];
  
  const horizontalClues = clues.filter(clue => clue.clueDirection === "Horizontal");
  const verticalClues = clues.filter(clue => clue.clueDirection === "Vertical");

  useEffect(() => {
    initializeScreen();
    setIsTimerRunning(true);
    setTimer(0);
  }, []);

  // const preparePuzzleArray = () => {
  //   return [
  //     [0, 0, 0, 0, 'p', 'a', 't', 'n', 'a', 0],
  //     [0, 0, 0, 0, 'u', 0, 0, 0, 0, 0],
  //     [0, 0, 0, 0, 'n', 0, 'b', 0, 0, 0],
  //     [0, 'h', 'y', 'd', 'e', 'r', 'a', 'b', 'a', 'd'],
  //     [0, 0, 0, 0, 0, 0, 'n', 0, 0, 'e'],
  //     [0, 0, 0, 0, 0, 0, 'g', 0, 0, 'l'],
  //     [0, 0, 'm', 'u', 'm', 'b', 'a', 'i', 0, 'h'],
  //     [0, 0, 0, 0, 0, 0, 'l', 0, 0, 'i'],
  //     [0, 0, 0, 0, 0, 0, 'o', 0, 0, 0],
  //     ['k', 'a', 's', 'h', 'm', 'i', 'r', 0, 0, 0],
  //     [0, 0, 0, 0, 0, 0, 'e', 0, 0, 0]
  //   ];
  // };

  // const preparePuzzleArray = () => {
  //   return [
  //     [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  //     [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  //     [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  //     [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  //     [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  //     [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  //     [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  //     [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  //     [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  //     [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  //     [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  //   ];
  // };

  const preparePuzzleArray = () => {
    return [
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 'n', 0],
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 'e', 0],
      [0, 0, 0, 0, 0, 0, 0, 0, 'h', 'e', 'l', 'i', 'u', 'm'],
      [0, 0, 0, 0, 'm', 0, 0, 0, 0, 0, 0, 0, 't', 0],
      ['c', 'a', 'r', 'b', 'o', 'n', 0, 0, 'd', 0, 'C', 0, 'r', 0],
      [0, 0, 0, 0, 'l', 0, 0, 0, 'i', 0, 'a', 0, 'o', 0],
      [0, 0, 0, 0, 'e', 0, 0, 'd', 'a', 'l', 't', 'o', 'n', 0],
      [0, 0, 0, 0, 'c', 0, 0, 0, 't', 0, 'i', 0, 0, 0],
      [0, 0, 0, 0, 'u', 0, 'p', 'r', 'o', 't', 'o', 'n', 0, 0],
      [0, 0, 0, 0, 'l', 0, 0, 0, 'm', 0, 'n', 0, 'i', 0],
      [0, 0, 0, 0, 'e', 0, 0, 0, 'i', 0, 0, 0, 'o', 0],
	  [0, 0, 0, 0, 0, 'e', 'l', 'e', 'c', 't', 'r', 'o', 'n', 0]
    ];
  };

  const initializeScreen = () => {
    setPuzzleArrayData(preparePuzzleArray());
  };

  const handleInputFocus = (txtID) => {
    setCurrentTextInput(txtID);
  };

  const handleCheckClicked = () => {
    const puzzleCopy = [...puzzleArrayData];
    puzzleCopy.forEach((row, i) => {
      row.forEach((cell, j) => {
        const inputID = `txt_${i}_${j}`;
        const inputElement = document.getElementById(inputID);
        if (cell !== 0 && inputElement.value !== cell) {
          inputElement.style.backgroundColor = 'red';
        } else if (cell !== 0) {
          inputElement.style.backgroundColor = 'white';
        }
      });
    });
  };

  const handleClueClicked = () => {
    if (currentTextInput) {
      const [_, row, column] = currentTextInput.split('_');
      const rowIndex = parseInt(row);
      const colIndex = parseInt(column);
      const inputElement = document.getElementById(currentTextInput);
      inputElement.value = puzzleArrayData[rowIndex][colIndex];
    }
  };

  const handleSolveClicked = () => {
    if (currentTextInput) {
      const [_, row, column] = currentTextInput.split('_');
      const rowIndex = parseInt(row);
      const colIndex = parseInt(column);
      // solve the puzzle for that position
      for (let i = rowIndex; i >= 0; i--) {
        if (puzzleArrayData[i][colIndex] !== 0) {
          document.getElementById(`txt_${i}_${colIndex}`).value = puzzleArrayData[i][colIndex];
        } else break;
      }

      for (let i = colIndex; i < puzzleArrayData[rowIndex].length; i++) {
        if (puzzleArrayData[rowIndex][i] !== 0) {
          document.getElementById(`txt_${rowIndex}_${i}`).value = puzzleArrayData[rowIndex][i];
        } else break;
      }

      for (let i = rowIndex; i < puzzleArrayData.length; i++) {
        if (puzzleArrayData[i][colIndex] !== 0) {
          document.getElementById(`txt_${i}_${colIndex}`).value = puzzleArrayData[i][colIndex];
        } else break;
      }

      for (let i = colIndex; i >= 0; i--) {
        if (puzzleArrayData[rowIndex][i] !== 0) {
          document.getElementById(`txt_${rowIndex}_${i}`).value = puzzleArrayData[rowIndex][i];
        } else break;
      }
    }
  };

  const handleClearAllClicked = () => {
    setCurrentTextInput(null);
    setPuzzleArrayData(preparePuzzleArray());
  };

  const [answersClicked, setAnswersClicked] = useState(false);
  const handleAnswersClicked = () => {
    setAnswersClicked(!answersClicked);
  };

  const handleTimerStart = () => {
    setIsTimerRunning(true);
    setTimer(0);
  };

  const handleTimerStop = () => {
    setIsTimerRunning(false);
  };

  useEffect(() => {
    let timerInterval;
    if (isTimerRunning) {
      timerInterval = setInterval(() => setTimer((prev) => prev + 1), 1000);
    }
    return () => clearInterval(timerInterval);
  }, [isTimerRunning]);

  const handleExitClicked = () => {
    navigate(-1);
  };

  return (
    <div className="flex flex-col bg-gray-600 [&_p]:text-white">
       <div className='flex flex-row justify-center mb-8'>
        <p className="text-2xl text-yellow-200">{puzzleTitle}</p>
       </div>
       <div className='flex flex-row justify-center'>
        <button className="mr-6 w-40" disabled={true} onClick={handleTimerStart}>Start Timer</button>
        <button className='w-80' disabled={true}>
            <span className='text-yellow-200'>Time: {timer} seconds</span>
        </button>
        <button className="ml-6 w-40" disabled={true} onClick={handleTimerStop}>Stop Timer</button>
      </div>
      <div className='flex justify-center'>
          <button className="butt" onClick={handleClearAllClicked}>Clear All</button>
          <button className="butt" onClick={handleCheckClicked}>Check</button>
          <button className="butt" onClick={handleSolveClicked}>Solve</button>
          <button className="butt" onClick={handleClueClicked}>Clue</button>
          <button className="butt" onClick={handleAnswersClicked}>Answers</button>
          <button className="butt" onClick={handleExitClicked}>Exit</button>
      </div>
      <div className='flex justify-center flex-row bg-blue-600'> 
        <div className='flex items-center'>
            <table id="puzzel">
            <tbody>
                {puzzleArrayData.map((rowData, rowIndex) => (
                <tr key={rowIndex}>
                    {rowData.map((cell, colIndex) => (
                    <td key={colIndex}>
                        {cell !== 0 ? (
                        <input
                            type="text"
                            className="inputBox text-blue-800"
                            maxLength="1"
                            id={`txt_${rowIndex}_${colIndex}`}
                            style={{ textTransform: 'lowercase', width: "40px" }}
                            onFocus={() => handleInputFocus(`txt_${rowIndex}_${colIndex}`)}
                        />
                        ) : (
                        <div className="bg-blue-600" />
                        )}
                    </td>
                    ))}
                </tr>
                ))}
            </tbody>
          </table>
        </div>
       </div>
       <div className='flex flex-col'>
            <div className="flex flex-row">
                <div className="bg-gray-500 p-4 m-2 w-1/2">
                    <table className="table-auto w-full">
                    <thead>
                        <tr>
                        <th colSpan="2" className="font-bold">Horizontal:</th>
                        </tr>
                    </thead>
                    <tbody>
                        {horizontalClues.map((clue, index) => (
                        <tr key={index}>
                            <td>{clue.hintNo}. {clue.clue} {answersClicked ? clue.answer : ''} ({clue.numberOfChar})</td>
                        </tr>
                        ))}
                    </tbody>
                    </table>
                </div>

                <div className="bg-gray-700 p-4 m-2 w-1/2">
                    <table className="table-auto w-full">
                    <thead>
                        <tr>
                        <th colSpan="2" className="font-bold">Vertical:</th>
                        </tr>
                    </thead>
                    <tbody>
                        {verticalClues.map((clue, index) => (
                        <tr key={index}>
                            <td>{clue.hintNo}. {clue.clue} {answersClicked ? clue.answer : ''} ({clue.numberOfChar})</td>
                        </tr>
                        ))}
                    </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
  );
};

export default Crossword;
